import { render, staticRenderFns } from "./CannyProductMenu.vue?vue&type=template&id=0610f6e0"
import script from "./CannyProductMenu.vue?vue&type=script&lang=js"
export * from "./CannyProductMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports